/*
 * Class: Layover
 *
 * Shows elements on a half transparent background
 * To show a layover, you can use
 * Layovers.show(NAME); // NAME = dom id
 *
 * Parameters:
 *
 *      content    - elm, which will be displayed
 *
 * Options:
 *
 *      closeClass - a click on a element with this class name will close the layover
 *      triggerElm - anchor or form element; submit will be executed, when all images are loaded
 *                   layover is not clickable, if triggerElm is given
 *      preload    - array of images, which will be preloaded
 */
var Layover = (function ($) {
    return Class.extend({
        layoverBackground: 'layoverBackground',

        init: function (content) {
            // move content to body to prevent z-index problem
            $('body').append(content);

            this.content = content;

            this.opt = Object.assign(
                {
                    closeClass: 'closeLayover',
                    removeOnClose: false,
                    triggerElm: null,
                    preload: [],
                },
                arguments[1] || {}
            );

            this.scrollListener = $.shove(this.onScroll, this);
        },

        reloadforAppleMobile: function () {
            if (stj.global.isAppleMobile()) {
                window.onpageshow = function (evt) {
                    if (evt.persisted) {
                        document.body.style.display = 'none';
                        location.reload();
                    }
                };
            }
        },

        show: function () {
            if (stj && stj.global && stj.global.newTab === false) {
                var self = this.opt;
                this.createBackground();
                this.prepareContent();
                $('#' + this.layoverBackground).show();
                $(this.content).show();
                this.reloadforAppleMobile();
            }
        },

        /*
         * is true, when elm is given, which can be triggered to do default action
         */
        triggerDefault: function () {
            var elm = this.opt.triggerElm;
            return (
                elm !== null && (elm.tagName === 'FORM' || elm.tagName === 'A')
            );
        },

        prepareContent: function () {
            var z =
                parseInt($('#' + this.layoverBackground).css('zIndex'), 10) + 1;
            var self = this;

            if ($(this.content).hasClass(this.opt.closeClass)) {
                $(this.content)
                    .off('click')
                    .on('click', $.shove(this.hide, this));
                $('#' + this.layoverBackground).addClass('close-cursor');
            }

            $(this.content)
                .find('.' + this.opt.closeClass)
                .off('click')
                .on('click', function (e) {
                    self.hide();
                    return false;
                });

            $(this.content).css('zIndex', z);

            if ($(this.content).css('position') === 'absolute') {
                $(window).on('scroll', this.scrollListener);
                this.onScroll();
            }
        },

        onScroll: function () {
            $(this.content).css('marginTop', $(window).scrollTop() + 'px');
        },

        createBackground: function () {
            $('#' + this.layoverBackground).remove();

            $(document.createElement('div'))
                .attr('id', this.layoverBackground)
                .addClass(this.layoverBackground)
                .height($(document).height())
                .appendTo('body')
                .on('click', $.shove(this.hide, this));
        },

        hide: function () {
            // only hide, if layover is not triggered by anchor
            if (!this.opt.triggerElm) {
                $('#' + this.layoverBackground).remove();
                $(window).off('scroll', this.scrollListener);

                if (this.opt.removeOnClose) {
                    $(this.content).remove();
                } else {
                    $(this.content).hide();
                }
            }
        },

        click: function (handler) {
            var self = this;

            $(this.content)
                .find('.' + this.opt.closeClass)
                .off('click')
                .on('click', handler)
                .on('click', function (e) {
                    self.hide();
                    return false;
                });
        },
    });
})(jQuery);

var Layovers = (function ($) {
    return {
        show: function (id, trigger, options) {
            var elm = $('#' + id).get(0);
            if (!elm) {
                return;
            }

            var opt = {
                triggerElm: trigger || null,
                preload: [],
            };

            opt = Object.assign(opt, options || {});

            var layover = new Layover(elm, opt);
            layover.show();

            return layover;
        },
    };
})(jQuery);
